import React from 'react'
import BrandPrinterSetup from '../BrandPrinterSetup'

const BrSearch = () => {
  return (
    <>
      <BrandPrinterSetup 
              brand="BROTHER" 
              image="https://support-printers.netlify.app/img/Brother-Logo.png" 
            />
    </>
  )
}

export default BrSearch
